<template>
    <Modal ref="modal" class="order-package-tracking-modal" @opened="onModalOpen" @closed="onModalClose">
        <template #header>
            <div class="h3">Suivi de colis de la commande {{ order.reference }}</div>
        </template>
        <template #body="sp">
            <div v-if="loading">
                <i class="fad fa-spinner fa-spin"></i> Chargement...
            </div>

            <ErrorsZone v-else-if="loadingErrors" :errors="loadingErrors"/>

            <div v-else-if="loaded">
                <div v-if="!packageTrackings || !packageTrackings.length">
                    Aucun numéro de suivi pour cette commande.
                </div>

                <table class="table">
                    <tbody>
                    <tr v-for="packageTracking in packageTrackings">
                        <td>
                            <button class="btn btn-danger btn-sm" :disabled="deleting" @click="deletePackageTracking(packageTracking)">
                                <i class="fa fa-times"></i>
                            </button>
                        </td>
                        <td>
                            <small>Numéro de suivi</small>
                            <div>
                                {{ packageTracking.tracking_number }}
                            </div>
                        </td>
                        <td>
                            <div v-if="packageTracking.description && packageTracking.description.trim()" class="mb-1">
                                {{ packageTracking.description }}
                            </div>

                            <ul class="list-group">
                                <li
                                    class="list-group-item p-0 d-flex"
                                    v-for="subcustomer in packageTracking.subcustomers">
                                    <div
                                        class="text-nowrap"
                                        v-if="!subcustomer.pivot.ref || subcustomer.pivot.ref.startsWith('(')"
                                    >
                                        n°<strong class="bg-light border border-danger px-1 ml-1 rounded text-danger">
                                        <i class="fad fa-exclamation-triangle"></i>
                                        <span>Inconnu</span>
                                    </strong>
                                    </div>
                                    <div class="text-nowrap" v-else>
                                        n°<strong class="bg-light border border-dark px-1 ml-1 rounded">{{ subcustomer.pivot.ref }}</strong>
                                    </div>
                                    <div class="list-group-item-subcustomer-name text-ellipsis">
                                        {{ subcustomer.name }}
                                    </div>
                                </li>
                            </ul>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <AddOrderPackageTrackingModal
                ref="modalAddOrderPackageTracking"
                :order="order"
                @trackingNumberAdded="onTrackingNumberAdded"
            />
        </template>
        <template #footer>
            <ErrorsZone v-if="errorsDeleting" :errors="errorsDeleting"></ErrorsZone>

            <div class="d-flex justify-content-between flex-row-reverse w-100">
                <button class="btn btn-secondary" @click="closeModal()">
                    <i class="fad fa-arrow-left"></i> Fermer
                </button>

                <button v-if="loaded" class="btn btn-primary" @click="$refs.modalAddOrderPackageTracking.showModal()">
                    <i class="fad fa-plus"></i> Ajouter un numéro de suivi
                </button>
            </div>
        </template>
    </Modal>
</template>

<script>
import AddOrderPackageTrackingModal from "./AddOrderPackageTrackingModal";
import ErrorsZone from "../ErrorsZone";
import Modal from "../Modal";

import {useGetLoader} from "../compositions/axios/loadingRequest";
import {useDeleteRequest} from "../compositions/axios/deleteRequest";

export default {
    name: 'OrderPackageTrackingModal',

    components: {
        AddOrderPackageTrackingModal,
        Modal,
        ErrorsZone,
    },

    setup() {
        const {
            loading,
            loaded,
            errors: loadingErrors,
            load,
        } = useGetLoader();

        const {
            deleting,
            errorsDeleting,
            doDelete,
        } = useDeleteRequest();

        return {
            loading,
            loaded,
            loadingErrors,
            load,
            deleting,
            errorsDeleting,
            doDelete,
        };
    },

    props: {
        order: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            packageTrackings: null,
        };
    },

    methods: {
        showModal() {
            this.$refs.modal.showModal();
        },

        closeModal() {
            this.$refs.modal.closeModal();
        },

        onModalOpen() {
            this.loadPackageTrackings();
        },

        onModalClose() {
            this.packageTrackings = null;
            this.errorsDeleting = null;
        },

        onTrackingNumberAdded() {
            this.loadPackageTrackings();
        },

        async deletePackageTracking(packageTracking) {
            if (!confirm(`Etes-vous sûr de vouloir supprimer le numéro de suivi '${packageTracking.tracking_number}' ?`)) {
                return;
            }
            const response = await this.doDelete(`/espace-employes/commandes/${this.order.id}/suivi-colis/${packageTracking.id}`);
            if (response && response.success) {
                this.loadPackageTrackings();
            }
        },

        async loadPackageTrackings() {
            this.packageTrackings = null;
            this.packageTrackings = await this.load(`/espace-employes/commandes/${this.order.id}/suivi-colis`);
        },
    },
}
</script>

<style lang="scss">
.order-package-tracking-modal {
    :first-of-type(.modal-container) {
        max-width: 1100px;
        width: auto;
    }

    .list-group-item-subcustomer-name {
        flex-grow: 1;
        margin-left: 9px;
    }
}
</style>
